var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.1579,
    height: 26.1818,
    transform: "translate(0 0.273438)",
    fill: "#F7FAF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27287 16.6369H12.5623M1.9834 10.9096H19.1742M15.2071 16.6369H16.5295M3.30577 6.00049C2.64458 6.00049 1.9834 6.81867 1.9834 7.63685V19.0914C1.9834 19.9096 2.64458 20.7278 3.30577 20.7278H17.8518C18.513 20.7278 19.1742 19.9096 19.1742 19.0914V7.63685C19.1742 6.81867 18.513 6.00049 17.8518 6.00049H3.30577Z",
    stroke: "#647F29",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.dd3e2206f3d066e24c29f7826e8ee30e.svg";
export { ForwardRef as ReactComponent };